import React from 'react';
import './TermsPage.css';

const TermsPage = () => {
  return (
    <div className="terms-page">
      <div className="container">
        <h1>Terms of Service</h1>
        <div className="terms-content">
          <section className="terms-section">
            <h2>Acceptance of Terms</h2>
            <p>
              By using SnapTools, you agree to be bound by these Terms of Service. If you do not agree
              to these terms, please do not use our services.
            </p>
            <p>
              We reserve the right to modify these terms at any time. Your continued use of SnapTools
              after such changes constitutes your acceptance of the new terms.
            </p>
          </section>
          
          <section className="terms-section">
            <h2>Use of Services</h2>
            <p>
              SnapTools provides browser-based image editing tools for personal and professional use.
              All tools are provided on an "as is" and "as available" basis.
            </p>
            <p>
              You agree to use our services only for lawful purposes and in a way that does not infringe upon
              the rights of others or restrict their use and enjoyment of the services.
            </p>
          </section>
          
          <section className="terms-section">
            <h2>Intellectual Property</h2>
            <p>
              The content, organization, graphics, design, and other matters related to SnapTools are
              protected under applicable copyrights, trademarks, and other proprietary rights.
            </p>
            <p>
              You retain all rights to your images and content. SnapTools does not claim ownership of any
              images processed through our tools.
            </p>
          </section>
          
          <section className="terms-section">
            <h2>User Content</h2>
            <p>
              You are solely responsible for the images and content you process using our tools. You agree not to use
              our services to process, create, or distribute content that is illegal, harmful, threatening, abusive, or otherwise objectionable.
            </p>
          </section>
          
          <section className="terms-section">
            <h2>Disclaimer of Warranties</h2>
            <p>
              SnapTools is provided "as is" without any warranties, expressed or implied. We do not guarantee
              that our services will be uninterrupted, secure, or error-free.
            </p>
            <p>
              We make no warranties about the accuracy, reliability, completeness, or timeliness of the services
              or the results that may be obtained from using them.
            </p>
          </section>
          
          <section className="terms-section">
            <h2>Limitation of Liability</h2>
            <p>
              In no event shall SnapTools, its operators, or affiliates be liable for any direct, indirect, incidental,
              special, or consequential damages arising out of the use or inability to use our services.
            </p>
          </section>
          
          <section className="terms-section">
            <h2>Contact</h2>
            <p>
              If you have any questions about these Terms of Service, please contact us at terms@snaptools.example.com.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsPage; 